document.addEventListener("DOMContentLoaded", function () {
	const sections = document.querySelectorAll(".testimonials-layout");

	sections.forEach(function (section) {
		const quotesWrapper = section.querySelector(".testimonial-quote-wrapper");
		const quotes = Array.from(section.querySelectorAll(".testimonial-quote"));
		const avatarsWrapper = section.querySelector(".testimonial-avatars");
		const avatars = Array.from(section.querySelectorAll(".testimonial-avatar"));
		const dots = Array.from(section.querySelectorAll(".testimonial-dots .dot"));

		if (!quotes.length || !avatars.length || !dots.length) return;

		let isInitialLoad = true;

		function setActive(index, shouldScroll) {
			quotes.forEach(function (q, i) {
				q.classList.toggle("active", i === index);
			});
			avatars.forEach(function (a, i) {
				a.classList.toggle("active", i === index);
			});
			dots.forEach(function (d, i) {
				d.classList.toggle("is-active", i === index);
			});

			// On mobile keep the active avatar in view (but not on initial load)
			if (
				shouldScroll !== false &&
				!isInitialLoad &&
				window.matchMedia("(max-width: 768px)").matches
			) {
				const avatar = avatars[index];
				if (avatar) {
					avatar.scrollIntoView({
						behavior: "smooth",
						inline: "center",
						block: "nearest",
					});
				}
			}
		}

		avatars.forEach(function (avatar) {
			const index = Number(avatar.dataset.customer);
			avatar.addEventListener("click", function () {
				setActive(index);
			});
		});

		dots.forEach(function (dot) {
			const index = Number(dot.dataset.index);
			dot.addEventListener("click", function () {
				setActive(index);
			});
		});

		// Horizontal scroll (mobile) update active dot/quote
		if (avatarsWrapper) {
			let scrollTimeout;
			avatarsWrapper.addEventListener("scroll", function () {
				if (!window.matchMedia("(max-width: 768px)").matches) return;

				clearTimeout(scrollTimeout);
				scrollTimeout = setTimeout(function () {
					const containerCenter =
						avatarsWrapper.scrollLeft + avatarsWrapper.offsetWidth / 2;
					let closestIndex = 0;
					let closestDistance = Infinity;

					avatars.forEach(function (avatar, i) {
						const avatarCenter = avatar.offsetLeft + avatar.offsetWidth / 2;
						const distance = Math.abs(containerCenter - avatarCenter);
						if (distance < closestDistance) {
							closestDistance = distance;
							closestIndex = i;
						}
					});
					setActive(closestIndex);
				}, 50);
			});
		}

		// Reset to first testimonial when crossing 768px breakpoint
		let previousWidth = window.innerWidth;
		window.addEventListener("resize", function () {
			const currentWidth = window.innerWidth;
			const isLarger768 =
				(previousWidth <= 768 && currentWidth > 768) ||
				(previousWidth > 768 && currentWidth <= 768);

			if (isLarger768) {
				setActive(0, false);
				if (avatarsWrapper) {
					avatarsWrapper.scrollLeft = 0;
				}
			}
			previousWidth = currentWidth;
		});

		setActive(0);
		isInitialLoad = false;
	});
});
